import { InputSelect } from '@abb-procure/common';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SearchFilterValueModel } from '../../models/search-filter-value.model';
import { SearchFilterValueDto } from '../../types/search-filter-value-dto.type';

@Component({
  selector: 'procure-search-filter-select',
  templateUrl: './search-filter-select.component.html',
  imports: [ReactiveFormsModule, InputSelect],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterSelect {
  readonly label = input.required<string>();

  readonly control =
    input.required<FormControl<SearchFilterValueDto[] | null>>();

  readonly options = input.required<SearchFilterValueDto[] | null>();

  readonly multiple = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected readonly selectOptions = computed(
    () =>
      this.options()?.map((option) => new SearchFilterValueModel(option)) ?? [],
  );
}
